// generated by scripts/extract-theme.mts — do not edit manually

export const theme = {
  borderRadius: {
    /**
     * @css-value [var(--theme-border-radius-large)](./css/vars/theme-border-radius.css)
     * @css-source [20px](./css/vars/theme-border-radius.css)
     * @see [./css/vars/theme-border-radius.css](./css/vars/theme-border-radius.css)
     */
    large: 'var(--theme-border-radius-large)',
    /**
     * @css-value [var(--theme-border-radius-medium)](./css/vars/theme-border-radius.css)
     * @css-source [18px](./css/vars/theme-border-radius.css)
     * @see [./css/vars/theme-border-radius.css](./css/vars/theme-border-radius.css)
     */
    medium: 'var(--theme-border-radius-medium)',
    /**
     * @css-value [var(--theme-border-radius-default)](./css/vars/theme-border-radius.css)
     * @css-source [10px](./css/vars/theme-border-radius.css)
     * @see [./css/vars/theme-border-radius.css](./css/vars/theme-border-radius.css)
     */
    default: 'var(--theme-border-radius-default)',
    /**
     * @css-value [var(--theme-border-radius-small)](./css/vars/theme-border-radius.css)
     * @css-source [5px](./css/vars/theme-border-radius.css)
     * @see [./css/vars/theme-border-radius.css](./css/vars/theme-border-radius.css)
     */
    small: 'var(--theme-border-radius-small)',
  },
  boxShadow: {
    /**
     * @css-value [var(--theme-box-shadow-default)](./css/vars/theme-box-shadow.css)
     * @css-source-light [0 5px 22px 0 rgba(0, 0, 0, 0.03), 0 1px 6px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.02)](./css/vars/theme-box-shadow.css)
     * @css-source-dark [0 2px 6px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.08), 0 0 1px 1px rgba(255, 255, 255, 0.2)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    default: 'var(--theme-box-shadow-default)',
    /**
     * @css-value [var(--theme-box-shadow-default-hover)](./css/vars/theme-box-shadow.css)
     * @css-source-light [0 5px 22px 0 rgba(0, 0, 0, 0.03), 0 2px 6px 0 rgba(0, 0, 0, 0.15), 0 2px 2px 0 rgba(0, 0, 0, 0.1)](./css/vars/theme-box-shadow.css)
     * @css-source-dark [0 2px 6px 0 rgba(0, 0, 0, 0.15), 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 0 1px 1px rgba(255, 255, 255, 0.3)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    default_hover: 'var(--theme-box-shadow-default-hover)',
    /**
     * @css-value [var(--theme-box-shadow-default-active)](./css/vars/theme-box-shadow.css)
     * @css-source-light [0 5px 22px 0 rgba(0, 0, 0, 0.07), 0 2px 6px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.2)](./css/vars/theme-box-shadow.css)
     * @css-source-dark [0 2px 6px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 0 1px 1px rgba(255, 255, 255, 0.4)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    default_active: 'var(--theme-box-shadow-default-active)',
    /**
     * @css-value [var(--theme-box-shadow-default-hover-combo)](./css/vars/theme-box-shadow.css)
     * @css-source [0 2px 6px 0 rgba(0, 0, 0, 0.1), 0 2px 4px 0 rgba(0, 0, 0, 0.1)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    default_hover_combo: 'var(--theme-box-shadow-default-hover-combo)',
    /**
     * @css-value [var(--theme-box-shadow-default-active-combo)](./css/vars/theme-box-shadow.css)
     * @css-source [0 2px 6px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.2)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    default_active_combo: 'var(--theme-box-shadow-default-active-combo)',
    /**
     * @css-value [var(--theme-box-shadow-scroll)](./css/vars/theme-box-shadow.css)
     * @css-source [0 0 20px 0 rgba(0, 0, 0, 0.1)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    scroll: 'var(--theme-box-shadow-scroll)',
    /**
     * @css-value [var(--theme-box-shadow-drag)](./css/vars/theme-box-shadow.css)
     * @css-source [0 5px 22px 0 rgba(0, 0, 0, 0.14), 0 2px 6px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.08)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    drag: 'var(--theme-box-shadow-drag)',
    /**
     * @css-value [var(--theme-box-shadow-hover)](./css/vars/theme-box-shadow.css)
     * @css-source [0 5px 22px 0 rgba(0, 0, 0, 0.0525), 0 2px 6px 0 rgba(0, 0, 0, 0.075), 0 2px 4px 0 rgba(0, 0, 0, 0.03)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    hover: 'var(--theme-box-shadow-hover)',
    /**
     * @css-value [var(--theme-box-shadow-drop)](./css/vars/theme-box-shadow.css)
     * @css-source [0 5px 22px 0 rgba(0, 130, 250, 0.07), 0 2px 6px 0 rgba(0, 130, 250, 0.1), 0 2px 4px 0 rgba(0, 130, 250, 0.08)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    drop: 'var(--theme-box-shadow-drop)',
    /**
     * @css-value [var(--theme-box-shadow-focus)](./css/vars/theme-box-shadow.css)
     * @css-source [0 0 3px 0px rgba(0, 130, 250, 0.5)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    focus: 'var(--theme-box-shadow-focus)',
    /**
     * @css-value [var(--theme-box-shadow-error)](./css/vars/theme-box-shadow.css)
     * @css-source [0 0 3px 0px rgba(216, 28, 29, 0.5)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     */
    error: 'var(--theme-box-shadow-error)',
    /**
     * @css-value [var(--theme-box-shadow-highlight)](./css/vars/theme-box-shadow.css)
     * @css-source [0 5px 22px 0 rgba(0, 130, 250, 0.14), 0 2px 6px 0 rgba(0, 130, 250, 0.2), 0 2px 4px 0 rgba(0, 130, 250, 0.08)](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-box-shadow.css](./css/vars/theme-box-shadow.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    highlight: 'var(--theme-box-shadow-highlight)',
  },
  color: {
    /**
     * @css-value [var(--theme-color-white)](./css/vars/theme-color.css)
     * @css-source [#ffffff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    white: 'var(--theme-color-white)',
    /**
     * @css-value [var(--theme-color-mono-000)](./css/vars/theme-color.css)
     * @css-source-light [#ffffff](./css/vars/theme-color.css)
     * @css-source-dark [#000000](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_000: 'var(--theme-color-mono-000)',
    /**
     * @css-value [var(--theme-color-mono-010)](./css/vars/theme-color.css)
     * @css-source-light [#fbfbfd](./css/vars/theme-color.css)
     * @css-source-dark [#08090c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_010: 'var(--theme-color-mono-010)',
    /**
     * @css-value [var(--theme-color-mono-020)](./css/vars/theme-color.css)
     * @css-source-light [#f1f2f6](./css/vars/theme-color.css)
     * @css-source-dark [#16171d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_020: 'var(--theme-color-mono-020)',
    /**
     * @css-value [var(--theme-color-mono-025)](./css/vars/theme-color.css)
     * @css-source-light [#f4f4fa](./css/vars/theme-color.css)
     * @css-source-dark [#111218](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_025: 'var(--theme-color-mono-025)',
    /**
     * @css-value [var(--theme-color-mono-050)](./css/vars/theme-color.css)
     * @css-source-light [#eaeaf1](./css/vars/theme-color.css)
     * @css-source-dark [#1e1f24](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_050: 'var(--theme-color-mono-050)',
    /**
     * @css-value [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-light [#dadae2](./css/vars/theme-color.css)
     * @css-source-dark [#292a2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_100: 'var(--theme-color-mono-100)',
    /**
     * @css-value [var(--theme-color-mono-150)](./css/vars/theme-color.css)
     * @css-source-light [#d1d2d5](./css/vars/theme-color.css)
     * @css-source-dark [#35363b](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_150: 'var(--theme-color-mono-150)',
    /**
     * @css-value [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-light [#c8c8d0](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_200: 'var(--theme-color-mono-200)',
    /**
     * @css-value [var(--theme-color-mono-300)](./css/vars/theme-color.css)
     * @css-source-light [#b1b1b9](./css/vars/theme-color.css)
     * @css-source-dark [#58595d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_300: 'var(--theme-color-mono-300)',
    /**
     * @css-value [var(--theme-color-mono-400)](./css/vars/theme-color.css)
     * @css-source-light [#93939a](./css/vars/theme-color.css)
     * @css-source-dark [#707175](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_400: 'var(--theme-color-mono-400)',
    /**
     * @css-value [var(--theme-color-mono-500)](./css/vars/theme-color.css)
     * @css-source-light [#7a7a7f](./css/vars/theme-color.css)
     * @css-source-dark [#88898c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_500: 'var(--theme-color-mono-500)',
    /**
     * @css-value [var(--theme-color-mono-600)](./css/vars/theme-color.css)
     * @css-source-light [#626265](./css/vars/theme-color.css)
     * @css-source-dark [#a0a0a3](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_600: 'var(--theme-color-mono-600)',
    /**
     * @css-value [var(--theme-color-mono-700)](./css/vars/theme-color.css)
     * @css-source-light [#49494a](./css/vars/theme-color.css)
     * @css-source-dark [#b8b8ba](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_700: 'var(--theme-color-mono-700)',
    /**
     * @css-value [var(--theme-color-mono-800)](./css/vars/theme-color.css)
     * @css-source-light [#303031](./css/vars/theme-color.css)
     * @css-source-dark [#cfcfd1](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_800: 'var(--theme-color-mono-800)',
    /**
     * @css-value [var(--theme-color-mono-900)](./css/vars/theme-color.css)
     * @css-source-light [#1c1c1c](./css/vars/theme-color.css)
     * @css-source-dark [#e7e7e8](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_900: 'var(--theme-color-mono-900)',
    /**
     * @css-value [var(--theme-color-mono-950)](./css/vars/theme-color.css)
     * @css-source-light [#0c0c0c](./css/vars/theme-color.css)
     * @css-source-dark [#f2f2f3](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_950: 'var(--theme-color-mono-950)',
    /**
     * @css-value [var(--theme-color-mono-1000)](./css/vars/theme-color.css)
     * @css-source-light [#000000](./css/vars/theme-color.css)
     * @css-source-dark [#ffffff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_1000: 'var(--theme-color-mono-1000)',
    /**
     * @css-value [var(--theme-color-black)](./css/vars/theme-color.css)
     * @css-source [#000000](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    black: 'var(--theme-color-black)',
    /**
     * @css-value [var(--theme-color-mono-o-02)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.02)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_o_02: 'var(--theme-color-mono-o-02)',
    /**
     * @css-value [var(--theme-color-mono-o-10)](./css/vars/theme-color.css)
     * @css-source-light [rgba(0, 0, 0, 0.1)](./css/vars/theme-color.css)
     * @css-source-dark [rgba(255, 255, 255, 0.1)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_o_10: 'var(--theme-color-mono-o-10)',
    /**
     * @css-value [var(--theme-color-mono-o-20)](./css/vars/theme-color.css)
     * @css-source-light [rgba(0, 0, 0, 0.2)](./css/vars/theme-color.css)
     * @css-source-dark [rgba(255, 255, 255, 0.2)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_o_20: 'var(--theme-color-mono-o-20)',
    /**
     * @css-value [var(--theme-color-mono-o-40)](./css/vars/theme-color.css)
     * @css-source-light [rgba(0, 0, 0, 0.4)](./css/vars/theme-color.css)
     * @css-source-dark [rgba(255, 255, 255, 0.4)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_o_40: 'var(--theme-color-mono-o-40)',
    /**
     * @css-value [var(--theme-color-mono-o-50)](./css/vars/theme-color.css)
     * @css-source-light [rgba(0, 0, 0, 0.5)](./css/vars/theme-color.css)
     * @css-source-dark [rgba(255, 255, 255, 0.5)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_o_50: 'var(--theme-color-mono-o-50)',
    /**
     * @css-value [var(--theme-color-white-o-0)](./css/vars/theme-color.css)
     * @css-source [rgba(255, 255, 255, 0)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    white_o_0: 'var(--theme-color-white-o-0)',
    /**
     * @css-value [var(--theme-color-white-o-20)](./css/vars/theme-color.css)
     * @css-source [rgba(255, 255, 255, 0.2)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    white_o_20: 'var(--theme-color-white-o-20)',
    /**
     * @css-value [var(--theme-color-white-o-50)](./css/vars/theme-color.css)
     * @css-source [rgba(255, 255, 255, 0.5)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    white_o_50: 'var(--theme-color-white-o-50)',
    /**
     * @css-value [var(--theme-color-white-o-75)](./css/vars/theme-color.css)
     * @css-source [rgba(255, 255, 255, 0.75)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    white_o_75: 'var(--theme-color-white-o-75)',
    /**
     * @css-value [var(--theme-color-white-o-100)](./css/vars/theme-color.css)
     * @css-source [rgba(255, 255, 255, 1)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    white_o_100: 'var(--theme-color-white-o-100)',
    /**
     * @css-value [var(--theme-color-black-o-0)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    black_o_0: 'var(--theme-color-black-o-0)',
    /**
     * @css-value [var(--theme-color-black-o-10)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.1)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    black_o_10: 'var(--theme-color-black-o-10)',
    /**
     * @css-value [var(--theme-color-black-o-30)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.3)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    black_o_30: 'var(--theme-color-black-o-30)',
    /**
     * @css-value [var(--theme-color-black-o-50)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.5)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    black_o_50: 'var(--theme-color-black-o-50)',
    /**
     * @css-value [var(--theme-color-black-o-60)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.6)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    black_o_60: 'var(--theme-color-black-o-60)',
    /**
     * @css-value [var(--theme-color-black-o-70)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.7)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    black_o_70: 'var(--theme-color-black-o-70)',
    /**
     * @css-value [var(--theme-color-black-o-80)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.8)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    black_o_80: 'var(--theme-color-black-o-80)',
    /**
     * @css-value [var(--theme-color-mono-ex030)](./css/vars/theme-color.css)
     * @css-source-light [#f1f1f8](./css/vars/theme-color.css)
     * @css-source-dark [#0d0e13](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_ex030: 'var(--theme-color-mono-ex030)',
    /**
     * @css-value [var(--theme-color-mono-ex037)](./css/vars/theme-color.css)
     * @css-source-light [#f1f1f8](./css/vars/theme-color.css)
     * @css-source-dark [#181920](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    mono_ex037: 'var(--theme-color-mono-ex037)',
    /**
     * @css-value [var(--theme-color-ice-white)](./css/vars/theme-color.css)
     * @css-source [#f4f4fa](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    ice_white: 'var(--theme-color-ice-white)',
    /**
     * @css-value [var(--theme-color-night-black)](./css/vars/theme-color.css)
     * @css-source [#121319](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    night_black: 'var(--theme-color-night-black)',
    /**
     * @css-value [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue: 'var(--theme-color-blue)',
    /**
     * @css-value [var(--theme-color-blue-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-light [#339bfb](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-300)](./css/vars/theme-color.css)
     * @css-source-dark [#66b4fc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_hover: 'var(--theme-color-blue-hover)',
    /**
     * @css-value [var(--theme-color-blue-active)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-600)](./css/vars/theme-color.css)
     * @css-source-light [#0068c8](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-dark [#0082fa](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_active: 'var(--theme-color-blue-active)',
    /**
     * @css-value [var(--theme-color-blue-050)](./css/vars/theme-color.css)
     * @css-source-light [#e6f3ff](./css/vars/theme-color.css)
     * @css-source-dark [#1e2c3d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_050: 'var(--theme-color-blue-050)',
    /**
     * @css-value [var(--theme-color-blue-100)](./css/vars/theme-color.css)
     * @css-source [#cce6fe](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_100: 'var(--theme-color-blue-100)',
    /**
     * @css-value [var(--theme-color-blue-200)](./css/vars/theme-color.css)
     * @css-source-light [#99cdfd](./css/vars/theme-color.css)
     * @css-source-dark [#1b3652](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_200: 'var(--theme-color-blue-200)',
    /**
     * @css-value [var(--theme-color-blue-300)](./css/vars/theme-color.css)
     * @css-source [#66b4fc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_300: 'var(--theme-color-blue-300)',
    /**
     * @css-value [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_400: 'var(--theme-color-blue-400)',
    /**
     * @css-value [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source [#0082fa](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_500: 'var(--theme-color-blue-500)',
    /**
     * @css-value [var(--theme-color-blue-600)](./css/vars/theme-color.css)
     * @css-source [#0068c8](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_600: 'var(--theme-color-blue-600)',
    /**
     * @css-value [var(--theme-color-blue-700)](./css/vars/theme-color.css)
     * @css-source [#004e96](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_700: 'var(--theme-color-blue-700)',
    /**
     * @css-value [var(--theme-color-blue-800)](./css/vars/theme-color.css)
     * @css-source [#003464](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_800: 'var(--theme-color-blue-800)',
    /**
     * @css-value [var(--theme-color-blue-900)](./css/vars/theme-color.css)
     * @css-source [#001a32](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_900: 'var(--theme-color-blue-900)',
    /**
     * @css-value [var(--theme-color-blue-o-05)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.05)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_o_05: 'var(--theme-color-blue-o-05)',
    /**
     * @css-value [var(--theme-color-blue-o-08)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.08)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_o_08: 'var(--theme-color-blue-o-08)',
    /**
     * @css-value [var(--theme-color-blue-o-10)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.1)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_o_10: 'var(--theme-color-blue-o-10)',
    /**
     * @css-value [var(--theme-color-blue-o-14)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.14)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_o_14: 'var(--theme-color-blue-o-14)',
    /**
     * @css-value [var(--theme-color-blue-o-20)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.2)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_o_20: 'var(--theme-color-blue-o-20)',
    /**
     * @css-value [var(--theme-color-blue-o-30)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.3)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_o_30: 'var(--theme-color-blue-o-30)',
    /**
     * @css-value [var(--theme-color-blue-o-50)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.5)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_o_50: 'var(--theme-color-blue-o-50)',
    /**
     * @css-value [var(--theme-color-blue-o-05-mono-000-b)](./css/vars/theme-color.css)
     * @css-source [#f2f9ff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_o_05_mono_000_b: 'var(--theme-color-blue-o-05-mono-000-b)',
    /**
     * @css-value [var(--theme-color-blue-o-10-mono-000-b)](./css/vars/theme-color.css)
     * @css-source [#e6f3ff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    blue_o_10_mono_000_b: 'var(--theme-color-blue-o-10-mono-000-b)',
    /**
     * @css-value [var(--theme-color---todo--blue-g-0)](./css/vars/theme-color.css)
     * @css-source [linear-gradient(270deg, rgb(0, 191, 255), rgb(0, 106, 255))](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    __todo__blue_g_0: 'var(--theme-color---todo--blue-g-0)',
    /**
     * @css-value [var(--theme-color---todo--blue-g-1)](./css/vars/theme-color.css)
     * @css-source [linear-gradient(270deg, rgb(25, 198, 255), rgb(26, 121, 255))](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    __todo__blue_g_1: 'var(--theme-color---todo--blue-g-1)',
    /**
     * @css-value [var(--theme-color---todo--blue-g-2)](./css/vars/theme-color.css)
     * @css-source [linear-gradient(270deg, rgb(0, 172, 230), rgb(0, 96, 230))](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    __todo__blue_g_2: 'var(--theme-color---todo--blue-g-2)',
    /**
     * @css-value [var(--theme-color-green)](./css/vars/theme-color.css)
     * @css-source [#3fc700](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green: 'var(--theme-color-green)',
    /**
     * @css-value [var(--theme-color-green-hover)](./css/vars/theme-color.css)
     * @css-source [#65d233](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_hover: 'var(--theme-color-green-hover)',
    /**
     * @css-value [var(--theme-color-green-active)](./css/vars/theme-color.css)
     * @css-source [#329f00](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_active: 'var(--theme-color-green-active)',
    /**
     * @css-value [var(--theme-color-green-050)](./css/vars/theme-color.css)
     * @css-source [#ecfae6](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_050: 'var(--theme-color-green-050)',
    /**
     * @css-value [var(--theme-color-green-100)](./css/vars/theme-color.css)
     * @css-source [#d9f4cc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_100: 'var(--theme-color-green-100)',
    /**
     * @css-value [var(--theme-color-green-200)](./css/vars/theme-color.css)
     * @css-source [#b2e999](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_200: 'var(--theme-color-green-200)',
    /**
     * @css-value [var(--theme-color-green-300)](./css/vars/theme-color.css)
     * @css-source [#8cdd66](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_300: 'var(--theme-color-green-300)',
    /**
     * @css-value [var(--theme-color-green-400)](./css/vars/theme-color.css)
     * @css-source [#65d233](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_400: 'var(--theme-color-green-400)',
    /**
     * @css-value [var(--theme-color-green-500)](./css/vars/theme-color.css)
     * @css-source [#3fc700](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_500: 'var(--theme-color-green-500)',
    /**
     * @css-value [var(--theme-color-green-600)](./css/vars/theme-color.css)
     * @css-source [#329f00](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_600: 'var(--theme-color-green-600)',
    /**
     * @css-value [var(--theme-color-green-700)](./css/vars/theme-color.css)
     * @css-source [#267700](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_700: 'var(--theme-color-green-700)',
    /**
     * @css-value [var(--theme-color-green-800)](./css/vars/theme-color.css)
     * @css-source [#195000](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_800: 'var(--theme-color-green-800)',
    /**
     * @css-value [var(--theme-color-green-900)](./css/vars/theme-color.css)
     * @css-source [#0d2800](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    green_900: 'var(--theme-color-green-900)',
    /**
     * @css-value [var(--theme-color-red)](./css/vars/theme-color.css)
     * @css-source [#d81c1d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red: 'var(--theme-color-red)',
    /**
     * @css-value [var(--theme-color-red-hover)](./css/vars/theme-color.css)
     * @css-source [#e0494a](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_hover: 'var(--theme-color-red-hover)',
    /**
     * @css-value [var(--theme-color-red-active)](./css/vars/theme-color.css)
     * @css-source [#ad1617](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_active: 'var(--theme-color-red-active)',
    /**
     * @css-value [var(--theme-color-red-050)](./css/vars/theme-color.css)
     * @css-source-light [#fce9e9](./css/vars/theme-color.css)
     * @css-source-dark [#3e1e1e](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_050: 'var(--theme-color-red-050)',
    /**
     * @css-value [var(--theme-color-red-100)](./css/vars/theme-color.css)
     * @css-source [#f7d2d2](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_100: 'var(--theme-color-red-100)',
    /**
     * @css-value [var(--theme-color-red-200)](./css/vars/theme-color.css)
     * @css-source [#efa4a5](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_200: 'var(--theme-color-red-200)',
    /**
     * @css-value [var(--theme-color-red-300)](./css/vars/theme-color.css)
     * @css-source [#e87777](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_300: 'var(--theme-color-red-300)',
    /**
     * @css-value [var(--theme-color-red-400)](./css/vars/theme-color.css)
     * @css-source [#e0494a](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_400: 'var(--theme-color-red-400)',
    /**
     * @css-value [var(--theme-color-red-500)](./css/vars/theme-color.css)
     * @css-source [#d81c1d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_500: 'var(--theme-color-red-500)',
    /**
     * @css-value [var(--theme-color-red-600)](./css/vars/theme-color.css)
     * @css-source [#ad1617](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_600: 'var(--theme-color-red-600)',
    /**
     * @css-value [var(--theme-color-red-700)](./css/vars/theme-color.css)
     * @css-source [#821111](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_700: 'var(--theme-color-red-700)',
    /**
     * @css-value [var(--theme-color-red-800)](./css/vars/theme-color.css)
     * @css-source [#560b0c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_800: 'var(--theme-color-red-800)',
    /**
     * @css-value [var(--theme-color-red-900)](./css/vars/theme-color.css)
     * @css-source [#2b0606](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_900: 'var(--theme-color-red-900)',
    /**
     * @css-value [var(--theme-color-red-o-05)](./css/vars/theme-color.css)
     * @css-source [rgba(216, 28, 29, 0.05)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_o_05: 'var(--theme-color-red-o-05)',
    /**
     * @css-value [var(--theme-color-red-o-08)](./css/vars/theme-color.css)
     * @css-source [rgba(216, 28, 29, 0.08)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_o_08: 'var(--theme-color-red-o-08)',
    /**
     * @css-value [var(--theme-color-red-o-14)](./css/vars/theme-color.css)
     * @css-source [rgba(216, 28, 29, 0.14)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_o_14: 'var(--theme-color-red-o-14)',
    /**
     * @css-value [var(--theme-color-red-o-20)](./css/vars/theme-color.css)
     * @css-source [rgba(216, 28, 29, 0.2)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_o_20: 'var(--theme-color-red-o-20)',
    /**
     * @css-value [var(--theme-color-red-o-50)](./css/vars/theme-color.css)
     * @css-source [rgba(216, 28, 29, 0.5)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_o_50: 'var(--theme-color-red-o-50)',
    /**
     * @css-value [var(--theme-color-red-o-80)](./css/vars/theme-color.css)
     * @css-source [rgba(216, 28, 29, 0.8)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    red_o_80: 'var(--theme-color-red-o-80)',
    /**
     * @css-value [var(--theme-color-yellow)](./css/vars/theme-color.css)
     * @css-source [#f5b207](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow: 'var(--theme-color-yellow)',
    /**
     * @css-value [var(--theme-color-yellow-hover)](./css/vars/theme-color.css)
     * @css-source [#f9c43e](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_hover: 'var(--theme-color-yellow-hover)',
    /**
     * @css-value [var(--theme-color-yellow-active)](./css/vars/theme-color.css)
     * @css-source [#e9a907](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_active: 'var(--theme-color-yellow-active)',
    /**
     * @css-value [var(--theme-color-yellow-025)](./css/vars/theme-color.css)
     * @css-source [#fefbf2](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_025: 'var(--theme-color-yellow-025)',
    /**
     * @css-value [var(--theme-color-yellow-050)](./css/vars/theme-color.css)
     * @css-source [#fef7e6](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_050: 'var(--theme-color-yellow-050)',
    /**
     * @css-value [var(--theme-color-yellow-100)](./css/vars/theme-color.css)
     * @css-source [#fdf0cd](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_100: 'var(--theme-color-yellow-100)',
    /**
     * @css-value [var(--theme-color-yellow-200)](./css/vars/theme-color.css)
     * @css-source [#fbe09c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_200: 'var(--theme-color-yellow-200)',
    /**
     * @css-value [var(--theme-color-yellow-300)](./css/vars/theme-color.css)
     * @css-source [#f9d16a](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_300: 'var(--theme-color-yellow-300)',
    /**
     * @css-value [var(--theme-color-yellow-400)](./css/vars/theme-color.css)
     * @css-source [#f7c139](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_400: 'var(--theme-color-yellow-400)',
    /**
     * @css-value [var(--theme-color-yellow-500)](./css/vars/theme-color.css)
     * @css-source [#f5b207](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_500: 'var(--theme-color-yellow-500)',
    /**
     * @css-value [var(--theme-color-yellow-600)](./css/vars/theme-color.css)
     * @css-source [#c48e06](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_600: 'var(--theme-color-yellow-600)',
    /**
     * @css-value [var(--theme-color-yellow-700)](./css/vars/theme-color.css)
     * @css-source [#936b04](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_700: 'var(--theme-color-yellow-700)',
    /**
     * @css-value [var(--theme-color-yellow-800)](./css/vars/theme-color.css)
     * @css-source [#624703](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_800: 'var(--theme-color-yellow-800)',
    /**
     * @css-value [var(--theme-color-yellow-900)](./css/vars/theme-color.css)
     * @css-source [#312401](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_900: 'var(--theme-color-yellow-900)',
    /**
     * @css-value [var(--theme-color-yellow-o-05)](./css/vars/theme-color.css)
     * @css-source [rgba(245, 178, 7, 0.05)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    yellow_o_05: 'var(--theme-color-yellow-o-05)',
    /**
     * @css-value [var(--theme-color-orange)](./css/vars/theme-color.css)
     * @css-source [#ff9713](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    orange: 'var(--theme-color-orange)',
    /**
     * @css-value [var(--theme-color-orange-0-20)](./css/vars/theme-color.css)
     * @css-source [rgba(255, 151, 19, 0.2)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    orange_0_20: 'var(--theme-color-orange-0-20)',
    /**
     * @css-value [var(--theme-color-special-favorite)](./css/vars/theme-color.css)
     * @css-source [#ff0000](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    special_favorite: 'var(--theme-color-special-favorite)',
    /**
     * @css-value [var(--theme-color-special-beta)](./css/vars/theme-color.css)
     * @css-source [#fa6400](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    special_beta: 'var(--theme-color-special-beta)',
    /**
     * @css-value [var(--theme-color-gradient-blue-active)](./css/vars/theme-color.css)
     * @css-source [#005cd5](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_blue_active: 'var(--theme-color-gradient-blue-active)',
    /**
     * @css-value [var(--theme-color-gradient-blue-start)](./css/vars/theme-color.css)
     * @css-source [#367cff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_blue_start: 'var(--theme-color-gradient-blue-start)',
    /**
     * @css-value [var(--theme-color-gradient-blue-end)](./css/vars/theme-color.css)
     * @css-source [#52baff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_blue_end: 'var(--theme-color-gradient-blue-end)',
    /**
     * @css-value [var(--theme-color-gradient-blue-hover)](./css/vars/theme-color.css)
     * @css-source [#52deff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_blue_hover: 'var(--theme-color-gradient-blue-hover)',
    /**
     * @css-value [var(--theme-color-gradient-pink-active)](./css/vars/theme-color.css)
     * @css-source [#c70076](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_pink_active: 'var(--theme-color-gradient-pink-active)',
    /**
     * @css-value [var(--theme-color-gradient-pink-start)](./css/vars/theme-color.css)
     * @css-source [#e90090](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_pink_start: 'var(--theme-color-gradient-pink-start)',
    /**
     * @css-value [var(--theme-color-gradient-pink-end)](./css/vars/theme-color.css)
     * @css-source [#fc6767](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_pink_end: 'var(--theme-color-gradient-pink-end)',
    /**
     * @css-value [var(--theme-color-gradient-pink-hover)](./css/vars/theme-color.css)
     * @css-source [#fc6767](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_pink_hover: 'var(--theme-color-gradient-pink-hover)',
    /**
     * @css-value [var(--theme-color-purple)](./css/vars/theme-color.css)
     * @css-source-light [#7500fb](./css/vars/theme-color.css)
     * @css-source-dark [#9033fc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    purple: 'var(--theme-color-purple)',
    /**
     * @css-value [var(--theme-color-gradient-purple-active)](./css/vars/theme-color.css)
     * @css-source [#751fff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_purple_active: 'var(--theme-color-gradient-purple-active)',
    /**
     * @css-value [var(--theme-color-gradient-purple-start)](./css/vars/theme-color.css)
     * @css-source [#881fff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_purple_start: 'var(--theme-color-gradient-purple-start)',
    /**
     * @css-value [var(--theme-color-gradient-purple-end)](./css/vars/theme-color.css)
     * @css-source [#d41dff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_purple_end: 'var(--theme-color-gradient-purple-end)',
    /**
     * @css-value [var(--theme-color-gradient-purple-hover)](./css/vars/theme-color.css)
     * @css-source [#e81dff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    gradient_purple_hover: 'var(--theme-color-gradient-purple-hover)',
    /**
     * @css-value [var(--theme-color-note-yellow)](./css/vars/theme-color.css)
     * @css-source [#fef49c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_yellow: 'var(--theme-color-note-yellow)',
    /**
     * @css-value [var(--theme-color-note-yellow-selected)](./css/vars/theme-color.css)
     * @css-source [#f8ee97](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_yellow_selected: 'var(--theme-color-note-yellow-selected)',
    /**
     * @css-value [var(--theme-color-note-yellow-focus)](./css/vars/theme-color.css)
     * @css-source [#fdf4a5](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_yellow_focus: 'var(--theme-color-note-yellow-focus)',
    /**
     * @css-value [var(--theme-color-note-yellow-border)](./css/vars/theme-color.css)
     * @css-source [#b0a96c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_yellow_border: 'var(--theme-color-note-yellow-border)',
    /**
     * @css-value [var(--theme-color-note-red)](./css/vars/theme-color.css)
     * @css-source [#ffc7c7](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_red: 'var(--theme-color-note-red)',
    /**
     * @css-value [var(--theme-color-note-red-selected)](./css/vars/theme-color.css)
     * @css-source [#fac3c3](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_red_selected: 'var(--theme-color-note-red-selected)',
    /**
     * @css-value [var(--theme-color-note-red-focus)](./css/vars/theme-color.css)
     * @css-source [#ffcccc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_red_focus: 'var(--theme-color-note-red-focus)',
    /**
     * @css-value [var(--theme-color-note-red-border)](./css/vars/theme-color.css)
     * @css-source [#b28a8a](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_red_border: 'var(--theme-color-note-red-border)',
    /**
     * @css-value [var(--theme-color-note-green)](./css/vars/theme-color.css)
     * @css-source [#b2ffa0](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_green: 'var(--theme-color-note-green)',
    /**
     * @css-value [var(--theme-color-note-green-selected)](./css/vars/theme-color.css)
     * @css-source [#aefa9c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_green_selected: 'var(--theme-color-note-green-selected)',
    /**
     * @css-value [var(--theme-color-note-green-focus)](./css/vars/theme-color.css)
     * @css-source [#b9ffa9](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_green_focus: 'var(--theme-color-note-green-focus)',
    /**
     * @css-value [var(--theme-color-note-green-border)](./css/vars/theme-color.css)
     * @css-source [#7cb26f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_green_border: 'var(--theme-color-note-green-border)',
    /**
     * @css-value [var(--theme-color-note-blue)](./css/vars/theme-color.css)
     * @css-source [#adf4ff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_blue: 'var(--theme-color-note-blue)',
    /**
     * @css-value [var(--theme-color-note-blue-selected)](./css/vars/theme-color.css)
     * @css-source [#a9effa](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_blue_selected: 'var(--theme-color-note-blue-selected)',
    /**
     * @css-value [var(--theme-color-note-blue-focus)](./css/vars/theme-color.css)
     * @css-source [#b5f5ff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_blue_focus: 'var(--theme-color-note-blue-focus)',
    /**
     * @css-value [var(--theme-color-note-blue-border)](./css/vars/theme-color.css)
     * @css-source [#78aab2](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    note_blue_border: 'var(--theme-color-note-blue-border)',
    /**
     * @css-value [var(--theme-color-logic-boolean)](./css/vars/theme-color.css)
     * @css-source [#fa6400](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_boolean: 'var(--theme-color-logic-boolean)',
    /**
     * @css-value [var(--theme-color-logic-boolean-hover)](./css/vars/theme-color.css)
     * @css-source [#e65c00](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_boolean_hover: 'var(--theme-color-logic-boolean-hover)',
    /**
     * @css-value [var(--theme-color-logic-boolean-active)](./css/vars/theme-color.css)
     * @css-source [#ff7b24](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_boolean_active: 'var(--theme-color-logic-boolean-active)',
    /**
     * @css-value [var(--theme-color-logic-image)](./css/vars/theme-color.css)
     * @css-source [#b620e0](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_image: 'var(--theme-color-logic-image)',
    /**
     * @css-value [var(--theme-color-logic-image-hover)](./css/vars/theme-color.css)
     * @css-source [#ab1dd2](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_image_hover: 'var(--theme-color-logic-image-hover)',
    /**
     * @css-value [var(--theme-color-logic-image-active)](./css/vars/theme-color.css)
     * @css-source [#bf3ae4](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_image_active: 'var(--theme-color-logic-image-active)',
    /**
     * @css-value [var(--theme-color-logic-number)](./css/vars/theme-color.css)
     * @css-source [#2fb0ff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_number: 'var(--theme-color-logic-number)',
    /**
     * @css-value [var(--theme-color-logic-number-hover)](./css/vars/theme-color.css)
     * @css-source [#14a6ff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_number_hover: 'var(--theme-color-logic-number-hover)',
    /**
     * @css-value [var(--theme-color-logic-number-active)](./css/vars/theme-color.css)
     * @css-source [#4dbbff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_number_active: 'var(--theme-color-logic-number-active)',
    /**
     * @css-value [var(--theme-color-logic-string)](./css/vars/theme-color.css)
     * @css-source [#75d600](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_string: 'var(--theme-color-logic-string)',
    /**
     * @css-value [var(--theme-color-logic-string-hover)](./css/vars/theme-color.css)
     * @css-source [#66c700](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_string_hover: 'var(--theme-color-logic-string-hover)',
    /**
     * @css-value [var(--theme-color-logic-string-active)](./css/vars/theme-color.css)
     * @css-source [#79eb00](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_string_active: 'var(--theme-color-logic-string-active)',
    /**
     * @css-value [var(--theme-color-logic-error)](./css/vars/theme-color.css)
     * @css-source [#d81c1d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_error: 'var(--theme-color-logic-error)',
    /**
     * @css-value [var(--theme-color-logic-error-hover)](./css/vars/theme-color.css)
     * @css-source [#c2191a](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_error_hover: 'var(--theme-color-logic-error-hover)',
    /**
     * @css-value [var(--theme-color-logic-error-active)](./css/vars/theme-color.css)
     * @css-source [#ea2425](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    logic_error_active: 'var(--theme-color-logic-error-active)',
    /**
     * @css-value [var(--theme-color-system-account)](./css/vars/theme-color.css)
     * @css-source [#f3ac16](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_account: 'var(--theme-color-system-account)',
    /**
     * @css-value [var(--theme-color-system-alarms)](./css/vars/theme-color.css)
     * @css-source [#e3292f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_alarms: 'var(--theme-color-system-alarms)',
    /**
     * @css-value [var(--theme-color-system-alexa)](./css/vars/theme-color.css)
     * @css-source [#00caff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_alexa: 'var(--theme-color-system-alexa)',
    /**
     * @css-value [var(--theme-color-system-api-keys)](./css/vars/theme-color.css)
     * @css-source [#452fb2](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_api_keys: 'var(--theme-color-system-api-keys)',
    /**
     * @css-value [var(--theme-color-system-appearance)](./css/vars/theme-color.css)
     * @css-source [#000000](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_appearance: 'var(--theme-color-system-appearance)',
    /**
     * @css-value [var(--theme-color-system-apps)](./css/vars/theme-color.css)
     * @css-source [#7538bc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_apps: 'var(--theme-color-system-apps)',
    /**
     * @css-value [var(--theme-color-system-audio)](./css/vars/theme-color.css)
     * @css-source [#ff491e](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_audio: 'var(--theme-color-system-audio)',
    /**
     * @css-value [var(--theme-color-system-backups)](./css/vars/theme-color.css)
     * @css-source [#00aef5](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_backups: 'var(--theme-color-system-backups)',
    /**
     * @css-value [var(--theme-color-system-batteries)](./css/vars/theme-color.css)
     * @css-source [#00c900](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_batteries: 'var(--theme-color-system-batteries)',
    /**
     * @css-value [var(--theme-color-system-coprocessor)](./css/vars/theme-color.css)
     * @css-source [#353535](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_coprocessor: 'var(--theme-color-system-coprocessor)',
    /**
     * @css-value [var(--theme-color-system-dashboards)](./css/vars/theme-color.css)
     * @css-source [#457ce0](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_dashboards: 'var(--theme-color-system-dashboards)',
    /**
     * @css-value [var(--theme-color-system-datetime)](./css/vars/theme-color.css)
     * @css-source [#e3282f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_datetime: 'var(--theme-color-system-datetime)',
    /**
     * @css-value [var(--theme-color-system-devices)](./css/vars/theme-color.css)
     * @css-source [#7243e1](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_devices: 'var(--theme-color-system-devices)',
    /**
     * @css-value [var(--theme-color-system-energy)](./css/vars/theme-color.css)
     * @css-source [#10c56e](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_energy: 'var(--theme-color-system-energy)',
    /**
     * @css-value [var(--theme-color-system-experiments)](./css/vars/theme-color.css)
     * @css-source [#387868](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_experiments: 'var(--theme-color-system-experiments)',
    /**
     * @css-value [var(--theme-color-system-family)](./css/vars/theme-color.css)
     * @css-source [#ff7f33](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_family: 'var(--theme-color-system-family)',
    /**
     * @css-value [var(--theme-color-system-feedback)](./css/vars/theme-color.css)
     * @css-source [#2fb2db](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_feedback: 'var(--theme-color-system-feedback)',
    /**
     * @css-value [var(--theme-color-system-flow)](./css/vars/theme-color.css)
     * @css-source [#3bcb18](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_flow: 'var(--theme-color-system-flow)',
    /**
     * @css-value [var(--theme-color-system-general)](./css/vars/theme-color.css)
     * @css-source [#454545](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_general: 'var(--theme-color-system-general)',
    /**
     * @css-value [var(--theme-color-system-google)](./css/vars/theme-color.css)
     * @css-source [#eb4139](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_google: 'var(--theme-color-system-google)',
    /**
     * @css-value [var(--theme-color-system-home)](./css/vars/theme-color.css)
     * @css-source [#494949](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_home: 'var(--theme-color-system-home)',
    /**
     * @css-value [var(--theme-color-system-homey-bridge)](./css/vars/theme-color.css)
     * @css-source [#2f2f2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_homey_bridge: 'var(--theme-color-system-homey-bridge)',
    /**
     * @css-value [var(--theme-color-system-homeyscript)](./css/vars/theme-color.css)
     * @css-source [#2c1e32](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_homeyscript: 'var(--theme-color-system-homeyscript)',
    /**
     * @css-value [var(--theme-color-system-infrared)](./css/vars/theme-color.css)
     * @css-source [#f32216](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_infrared: 'var(--theme-color-system-infrared)',
    /**
     * @css-value [var(--theme-color-system-insights)](./css/vars/theme-color.css)
     * @css-source [#452d76](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_insights: 'var(--theme-color-system-insights)',
    /**
     * @css-value [var(--theme-color-system-language)](./css/vars/theme-color.css)
     * @css-source [#00c1be](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_language: 'var(--theme-color-system-language)',
    /**
     * @css-value [var(--theme-color-system-ledring)](./css/vars/theme-color.css)
     * @css-source [#f79128](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_ledring: 'var(--theme-color-system-ledring)',
    /**
     * @css-value [var(--theme-color-system-location)](./css/vars/theme-color.css)
     * @css-source [#7cd516](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_location: 'var(--theme-color-system-location)',
    /**
     * @css-value [var(--theme-color-system-logic)](./css/vars/theme-color.css)
     * @css-source [#2aa733](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_logic: 'var(--theme-color-system-logic)',
    /**
     * @css-value [var(--theme-color-system-matter)](./css/vars/theme-color.css)
     * @css-source [#2c2c37](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_matter: 'var(--theme-color-system-matter)',
    /**
     * @css-value [var(--theme-color-system-moods)](./css/vars/theme-color.css)
     * @css-source [#5c5ad7](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_moods: 'var(--theme-color-system-moods)',
    /**
     * @css-value [var(--theme-color-system-more)](./css/vars/theme-color.css)
     * @css-source [#454545](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_more: 'var(--theme-color-system-more)',
    /**
     * @css-value [var(--theme-color-system-ota)](./css/vars/theme-color.css)
     * @css-source [#650bd2](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_ota: 'var(--theme-color-system-ota)',
    /**
     * @css-value [var(--theme-color-system-premium)](./css/vars/theme-color.css)
     * @css-source [#f4317b](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_premium: 'var(--theme-color-system-premium)',
    /**
     * @css-value [var(--theme-color-system-presence)](./css/vars/theme-color.css)
     * @css-source [#ade127](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_presence: 'var(--theme-color-system-presence)',
    /**
     * @css-value [var(--theme-color-system-push-notifications)](./css/vars/theme-color.css)
     * @css-source [#235b7d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_push_notifications: 'var(--theme-color-system-push-notifications)',
    /**
     * @css-value [var(--theme-color-system-reminders)](./css/vars/theme-color.css)
     * @css-source [#e01310](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_reminders: 'var(--theme-color-system-reminders)',
    /**
     * @css-value [var(--theme-color-system-review)](./css/vars/theme-color.css)
     * @css-source [#ef0048](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_review: 'var(--theme-color-system-review)',
    /**
     * @css-value [var(--theme-color-system-rf433)](./css/vars/theme-color.css)
     * @css-source [#2c2c37](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_rf433: 'var(--theme-color-system-rf433)',
    /**
     * @css-value [var(--theme-color-system-safety)](./css/vars/theme-color.css)
     * @css-source [#ef1965](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_safety: 'var(--theme-color-system-safety)',
    /**
     * @css-value [var(--theme-color-system-satelite)](./css/vars/theme-color.css)
     * @css-source [#6d2fc7](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_satelite: 'var(--theme-color-system-satelite)',
    /**
     * @css-value [var(--theme-color-system-security)](./css/vars/theme-color.css)
     * @css-source [#495964](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_security: 'var(--theme-color-system-security)',
    /**
     * @css-value [var(--theme-color-system-settings)](./css/vars/theme-color.css)
     * @css-source [#343434](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_settings: 'var(--theme-color-system-settings)',
    /**
     * @css-value [var(--theme-color-system-siri-shortcuts)](./css/vars/theme-color.css)
     * @css-source [#1c1f56](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_siri_shortcuts: 'var(--theme-color-system-siri-shortcuts)',
    /**
     * @css-value [var(--theme-color-system-speech)](./css/vars/theme-color.css)
     * @css-source [#14bdd8](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_speech: 'var(--theme-color-system-speech)',
    /**
     * @css-value [var(--theme-color-system-support)](./css/vars/theme-color.css)
     * @css-source [#3c85c3](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_support: 'var(--theme-color-system-support)',
    /**
     * @css-value [var(--theme-color-system-timeline-notifications)](./css/vars/theme-color.css)
     * @css-source [#ffcd00](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_timeline_notifications: 'var(--theme-color-system-timeline-notifications)',
    /**
     * @css-value [var(--theme-color-system-updates)](./css/vars/theme-color.css)
     * @css-source [#d20bcb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_updates: 'var(--theme-color-system-updates)',
    /**
     * @css-value [var(--theme-color-system-zwave)](./css/vars/theme-color.css)
     * @css-source [#20365e](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_zwave: 'var(--theme-color-system-zwave)',
    /**
     * @css-value [var(--theme-color-system-zigbee)](./css/vars/theme-color.css)
     * @css-source [#e82249](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_zigbee: 'var(--theme-color-system-zigbee)',
    /**
     * @css-value [var(--theme-color-system-zone)](./css/vars/theme-color.css)
     * @css-source [#494949](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    system_zone: 'var(--theme-color-system-zone)',
    /**
     * @css-value [var(--theme-color-highlight)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    highlight: 'var(--theme-color-highlight)',
    /**
     * @css-value [var(--theme-color-highlight-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-light [#339bfb](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-hover)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-300)](./css/vars/theme-color.css)
     * @css-source-dark [#66b4fc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    highlight_hover: 'var(--theme-color-highlight-hover)',
    /**
     * @css-value [var(--theme-color-highlight-active)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-active)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-600)](./css/vars/theme-color.css)
     * @css-source-light [#0068c8](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-active)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-dark [#0082fa](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    highlight_active: 'var(--theme-color-highlight-active)',
    /**
     * @css-value [var(--theme-color-highlight-background)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-o-10-mono-000-b)](./css/vars/theme-color.css)
     * @css-source-light [#e6f3ff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-o-10-mono-050-b)](./css/vars/theme-color.css)
     * @css-source-dark [#1d242f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    highlight_background: 'var(--theme-color-highlight-background)',
    /**
     * @css-value [var(--theme-color-highlight-component-on)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-o-10-mono-000-b)](./css/vars/theme-color.css)
     * @css-source-light [#e6f3ff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-o-10-mono-200-b)](./css/vars/theme-color.css)
     * @css-source-dark [#3c444e](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    highlight_component_on: 'var(--theme-color-highlight-component-on)',
    /**
     * @css-value [var(--theme-color-highlight-border)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-blue-o-10)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.1)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    highlight_border: 'var(--theme-color-highlight-border)',
    /**
     * @css-value [var(--theme-color-focus-ring)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-highlight)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-highlight)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    focus_ring: 'var(--theme-color-focus-ring)',
    /**
     * @css-value [var(--theme-color-text)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-900)](./css/vars/theme-color.css)
     * @css-source-light [#1c1c1c](./css/vars/theme-color.css)
     * @css-source-dark [#e7e7e8](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text: 'var(--theme-color-text)',
    /**
     * @css-value [var(--theme-color-text-light)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-400)](./css/vars/theme-color.css)
     * @css-source-light [#93939a](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-600)](./css/vars/theme-color.css)
     * @css-source-dark [#a0a0a3](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_light: 'var(--theme-color-text-light)',
    /**
     * @css-value [var(--theme-color-text-light-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-500)](./css/vars/theme-color.css)
     * @css-source-light [#7a7a7f](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-700)](./css/vars/theme-color.css)
     * @css-source-dark [#b8b8ba](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_light_hover: 'var(--theme-color-text-light-hover)',
    /**
     * @css-value [var(--theme-color-text-body-light)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-500)](./css/vars/theme-color.css)
     * @css-source-light [#7a7a7f](./css/vars/theme-color.css)
     * @css-source-dark [#88898c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_body_light: 'var(--theme-color-text-body-light)',
    /**
     * @css-value [var(--theme-color-text-highlight)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_highlight: 'var(--theme-color-text-highlight)',
    /**
     * @css-value [var(--theme-color-text-highlight-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-600)](./css/vars/theme-color.css)
     * @css-source-light [#0068c8](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-300)](./css/vars/theme-color.css)
     * @css-source-dark [#66b4fc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_highlight_hover: 'var(--theme-color-text-highlight-hover)',
    /**
     * @css-value [var(--theme-color-text-link)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_link: 'var(--theme-color-text-link)',
    /**
     * @css-value [var(--theme-color-text-link-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-light [#339bfb](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-hover)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-300)](./css/vars/theme-color.css)
     * @css-source-dark [#66b4fc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_link_hover: 'var(--theme-color-text-link-hover)',
    /**
     * @css-value [var(--theme-color-text-invert)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-000)](./css/vars/theme-color.css)
     * @css-source-light [#ffffff](./css/vars/theme-color.css)
     * @css-source-dark [#000000](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_invert: 'var(--theme-color-text-invert)',
    /**
     * @css-value [var(--theme-color-text-invert-o-50)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-white-o-50)](./css/vars/theme-color.css)
     * @css-source [rgba(255, 255, 255, 0.5)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_invert_o_50: 'var(--theme-color-text-invert-o-50)',
    /**
     * @css-value [var(--theme-color-text-disabled)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-300)](./css/vars/theme-color.css)
     * @css-source-light [#b1b1b9](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-400)](./css/vars/theme-color.css)
     * @css-source-dark [#707175](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_disabled: 'var(--theme-color-text-disabled)',
    /**
     * @css-value [var(--theme-color-text-inactive)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-light [#c8c8d0](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_inactive: 'var(--theme-color-text-inactive)',
    /**
     * @css-value [var(--theme-color-text-white)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-white)](./css/vars/theme-color.css)
     * @css-source [#ffffff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_white: 'var(--theme-color-text-white)',
    /**
     * @css-value [var(--theme-color-text-white-o-50)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-white-o-50)](./css/vars/theme-color.css)
     * @css-source [rgba(255, 255, 255, 0.5)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_white_o_50: 'var(--theme-color-text-white-o-50)',
    /**
     * @css-value [var(--theme-color-text-black)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-900)](./css/vars/theme-color.css)
     * @css-source-light [#1c1c1c](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-dark [#292a2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_black: 'var(--theme-color-text-black)',
    /**
     * @css-value [var(--theme-color-text-black-o-30)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-black-o-30)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.3)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_black_o_30: 'var(--theme-color-text-black-o-30)',
    /**
     * @css-value [var(--theme-color-text-black-o-60)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-black-o-60)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.6)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_black_o_60: 'var(--theme-color-text-black-o-60)',
    /**
     * @css-value [var(--theme-color-text-black-o-70)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-black-o-70)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.7)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_black_o_70: 'var(--theme-color-text-black-o-70)',
    /**
     * @css-value [var(--theme-color-text-black-o-80)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-black-o-80)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 0, 0, 0.8)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    text_black_o_80: 'var(--theme-color-text-black-o-80)',
    /**
     * @css-value [var(--theme-color-line)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-light [#dadae2](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    line: 'var(--theme-color-line)',
    /**
     * @css-value [var(--theme-color-line-hover)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-300)](./css/vars/theme-color.css)
     * @css-source-light [#b1b1b9](./css/vars/theme-color.css)
     * @css-source-dark [#58595d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    line_hover: 'var(--theme-color-line-hover)',
    /**
     * @css-value [var(--theme-color-line-light)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-020)](./css/vars/theme-color.css)
     * @css-source-light [#f1f2f6](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-dark [#292a2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    line_light: 'var(--theme-color-line-light)',
    /**
     * @css-value [var(--theme-color-grid)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-050)](./css/vars/theme-color.css)
     * @css-source-light [#eaeaf1](./css/vars/theme-color.css)
     * @css-source-dark [#1e1f24](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    grid: 'var(--theme-color-grid)',
    /**
     * @css-value [var(--theme-color-icon-white)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-white)](./css/vars/theme-color.css)
     * @css-source [#ffffff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_white: 'var(--theme-color-icon-white)',
    /**
     * @css-value [var(--theme-color-icon-light)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-300)](./css/vars/theme-color.css)
     * @css-source-light [#b1b1b9](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-600)](./css/vars/theme-color.css)
     * @css-source-dark [#a0a0a3](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_light: 'var(--theme-color-icon-light)',
    /**
     * @css-value [var(--theme-color-icon-light-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-400)](./css/vars/theme-color.css)
     * @css-source-light [#93939a](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-700)](./css/vars/theme-color.css)
     * @css-source-dark [#b8b8ba](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_light_hover: 'var(--theme-color-icon-light-hover)',
    /**
     * @css-value [var(--theme-color-icon-light-active)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-500)](./css/vars/theme-color.css)
     * @css-source-light [#7a7a7f](./css/vars/theme-color.css)
     * @css-source-dark [#88898c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_light_active: 'var(--theme-color-icon-light-active)',
    /**
     * @css-value [var(--theme-color-icon-light-inactive)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-050)](./css/vars/theme-color.css)
     * @css-source-light [#eaeaf1](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_light_inactive: 'var(--theme-color-icon-light-inactive)',
    /**
     * @css-value [var(--theme-color-icon-body-light)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-400)](./css/vars/theme-color.css)
     * @css-source-light [#93939a](./css/vars/theme-color.css)
     * @css-source-dark [#707175](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_body_light: 'var(--theme-color-icon-body-light)',
    /**
     * @css-value [var(--theme-color-icon-body-light-hover)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-500)](./css/vars/theme-color.css)
     * @css-source-light [#7a7a7f](./css/vars/theme-color.css)
     * @css-source-dark [#88898c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_body_light_hover: 'var(--theme-color-icon-body-light-hover)',
    /**
     * @css-value [var(--theme-color-icon-dark)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-800)](./css/vars/theme-color.css)
     * @css-source-light [#303031](./css/vars/theme-color.css)
     * @css-source-dark [#cfcfd1](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_dark: 'var(--theme-color-icon-dark)',
    /**
     * @css-value [var(--theme-color-icon-dark-hover)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-900)](./css/vars/theme-color.css)
     * @css-source-light [#1c1c1c](./css/vars/theme-color.css)
     * @css-source-dark [#e7e7e8](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_dark_hover: 'var(--theme-color-icon-dark-hover)',
    /**
     * @css-value [var(--theme-color-icon-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_blue: 'var(--theme-color-icon-blue)',
    /**
     * @css-value [var(--theme-color-icon-disabled)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-light [#dadae2](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    icon_disabled: 'var(--theme-color-icon-disabled)',
    /**
     * @css-value [var(--theme-color-body)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-025)](./css/vars/theme-color.css)
     * @css-source-light [#f4f4fa](./css/vars/theme-color.css)
     * @css-source-dark [#111218](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    body: 'var(--theme-color-body)',
    /**
     * @css-value [var(--theme-color-component)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-000)](./css/vars/theme-color.css)
     * @css-source-light [#ffffff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-050)](./css/vars/theme-color.css)
     * @css-source-dark [#1e1f24](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    component: 'var(--theme-color-component)',
    /**
     * @css-value [var(--theme-color-component-highlight)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-000)](./css/vars/theme-color.css)
     * @css-source-light [#ffffff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-dark [#292a2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    component_highlight: 'var(--theme-color-component-highlight)',
    /**
     * @css-value [var(--theme-color-component-on)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-000)](./css/vars/theme-color.css)
     * @css-source-light [#ffffff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-dark [#292a2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    component_on: 'var(--theme-color-component-on)',
    /**
     * @css-value [var(--theme-color-component-off)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-ex037)](./css/vars/theme-color.css)
     * @css-source-light [#f1f1f8](./css/vars/theme-color.css)
     * @css-source-dark [#181920](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    component_off: 'var(--theme-color-component-off)',
    /**
     * @css-value [var(--theme-color-component-line)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-light [#dadae2](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-300)](./css/vars/theme-color.css)
     * @css-source-dark [#58595d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    component_line: 'var(--theme-color-component-line)',
    /**
     * @css-value [var(--theme-color-overlay)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-black-o-50)](./css/vars/theme-color.css)
     * @css-source-light [rgba(0, 0, 0, 0.5)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-black-o-80)](./css/vars/theme-color.css)
     * @css-source-dark [rgba(0, 0, 0, 0.8)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    overlay: 'var(--theme-color-overlay)',
    /**
     * @css-value [var(--theme-color-background-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-025)](./css/vars/theme-color.css)
     * @css-source-light [#f4f4fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-dark [#292a2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    background_hover: 'var(--theme-color-background-hover)',
    /**
     * @css-value [var(--theme-color-scroll-shadow)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-black-o-10)](./css/vars/theme-color.css)
     * @css-source-light [rgba(0, 0, 0, 0.1)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-black-o-70)](./css/vars/theme-color.css)
     * @css-source-dark [rgba(0, 0, 0, 0.7)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    scroll_shadow: 'var(--theme-color-scroll-shadow)',
    /**
     * @css-value [var(--theme-color-danger)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-red)](./css/vars/theme-color.css)
     * @css-source [#d81c1d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    danger: 'var(--theme-color-danger)',
    /**
     * @css-value [var(--theme-color-danger-icon-hover)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-red-o-80)](./css/vars/theme-color.css)
     * @css-source [rgba(216, 28, 29, 0.8)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    danger_icon_hover: 'var(--theme-color-danger-icon-hover)',
    /**
     * @css-value [var(--theme-color-danger-text)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-red)](./css/vars/theme-color.css)
     * @css-source [#d81c1d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    danger_text: 'var(--theme-color-danger-text)',
    /**
     * @css-value [var(--theme-color-danger-background)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-red-o-05)](./css/vars/theme-color.css)
     * @css-source [rgba(216, 28, 29, 0.05)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    danger_background: 'var(--theme-color-danger-background)',
    /**
     * @css-value [var(--theme-color-success)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-green)](./css/vars/theme-color.css)
     * @css-source [#3fc700](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    success: 'var(--theme-color-success)',
    /**
     * @css-value [var(--theme-color-error)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-red)](./css/vars/theme-color.css)
     * @css-source [#d81c1d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    error: 'var(--theme-color-error)',
    /**
     * @css-value [var(--theme-color-warning)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-orange)](./css/vars/theme-color.css)
     * @css-source [#ff9713](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    warning: 'var(--theme-color-warning)',
    /**
     * @css-value [var(--theme-color-state-drop-line)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    state_drop_line: 'var(--theme-color-state-drop-line)',
    /**
     * @css-value [var(--theme-color-state-drop-background)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-blue-o-05)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.05)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    state_drop_background: 'var(--theme-color-state-drop-background)',
    /**
     * @css-value [var(--theme-color-state-droparea-background)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-050)](./css/vars/theme-color.css)
     * @css-source-light [#eaeaf1](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-020)](./css/vars/theme-color.css)
     * @css-source-dark [#16171d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    state_droparea_background: 'var(--theme-color-state-droparea-background)',
    /**
     * @css-value [var(--theme-color-state-hover-background)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-020)](./css/vars/theme-color.css)
     * @css-source-light [#f1f2f6](./css/vars/theme-color.css)
     * @css-source-dark [#16171d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    state_hover_background: 'var(--theme-color-state-hover-background)',
    /**
     * @css-value [var(--theme-color-selection-background)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-blue-o-05)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.05)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    selection_background: 'var(--theme-color-selection-background)',
    /**
     * @css-value [var(--theme-color-selection-border)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    selection_border: 'var(--theme-color-selection-border)',
    /**
     * @css-value [var(--theme-color-selected-background)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-o-05-mono-000-b)](./css/vars/theme-color.css)
     * @css-source-light [#f2f9ff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-o-10-mono-100-b)](./css/vars/theme-color.css)
     * @css-source-dark [#272e39](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    selected_background: 'var(--theme-color-selected-background)',
    /**
     * @css-value [var(--theme-color-selected-border)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    selected_border: 'var(--theme-color-selected-border)',
  },
  device: {
    /**
     * @css-value [var(--theme-device-size-small)](./css/vars/theme-device.css)
     * @css-source [60px](./css/vars/theme-device.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     */
    size_small: 'var(--theme-device-size-small)',
    /**
     * @css-value [var(--theme-device-size-medium)](./css/vars/theme-device.css)
     * @css-source [120px](./css/vars/theme-device.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     */
    size_medium: 'var(--theme-device-size-medium)',
    /**
     * @css-value [var(--theme-device-size-large)](./css/vars/theme-device.css)
     * @css-source [206px](./css/vars/theme-device.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     */
    size_large: 'var(--theme-device-size-large)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-off-fill)](./css/vars/theme-device.css)
     * @css-value-path [var(--theme-color-mono-050)](./css/vars/theme-color.css)
     * @css-source-light [#eaeaf1](./css/vars/theme-color.css)
     * @css-source-dark [#1e1f24](./css/vars/theme-color.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    tile_quick_action_off_fill: 'var(--theme-device-tile-quick-action-off-fill)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-off-fill-tile)](./css/vars/theme-device.css)
     * @css-source-light [#dfdfe7](./css/vars/theme-device.css)
     * @css-value-path-dark [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-dark [#292a2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    tile_quick_action_off_fill_tile: 'var(--theme-device-tile-quick-action-off-fill-tile)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-off-glyph)](./css/vars/theme-device.css)
     * @css-value-path-light [var(--theme-color-mono-600)](./css/vars/theme-color.css)
     * @css-source-light [#626265](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-900)](./css/vars/theme-color.css)
     * @css-source-dark [#e7e7e8](./css/vars/theme-color.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    tile_quick_action_off_glyph: 'var(--theme-device-tile-quick-action-off-glyph)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-off-press-in-fill)](./css/vars/theme-device.css)
     * @css-value-path-light [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-light [#dadae2](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    tile_quick_action_off_press_in_fill: 'var(--theme-device-tile-quick-action-off-press-in-fill)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-off-press-in-glyph)](./css/vars/theme-device.css)
     * @css-value-path [var(--theme-color-mono-700)](./css/vars/theme-color.css)
     * @css-source-light [#49494a](./css/vars/theme-color.css)
     * @css-source-dark [#b8b8ba](./css/vars/theme-color.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    tile_quick_action_off_press_in_glyph:
      'var(--theme-device-tile-quick-action-off-press-in-glyph)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-on-off-fill)](./css/vars/theme-device.css)
     * @css-source-light [rgba(0, 130, 250, 0.1)](./css/vars/theme-device.css)
     * @css-source-dark [rgba(51, 155, 251, 0.2)](./css/vars/theme-device.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     */
    tile_quick_action_on_off_fill: 'var(--theme-device-tile-quick-action-on-off-fill)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-on-off-glyph)](./css/vars/theme-device.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    tile_quick_action_on_off_glyph: 'var(--theme-device-tile-quick-action-on-off-glyph)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-on-off-press-in-fill)](./css/vars/theme-device.css)
     * @css-source-light [rgba(0, 130, 250, 0.2)](./css/vars/theme-device.css)
     * @css-source-dark [rgba(51, 155, 251, 0.4)](./css/vars/theme-device.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     */
    tile_quick_action_on_off_press_in_fill:
      'var(--theme-device-tile-quick-action-on-off-press-in-fill)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-on-off-press-in-glyph)](./css/vars/theme-device.css)
     * @css-value-path-light [var(--theme-color-blue-600)](./css/vars/theme-color.css)
     * @css-source-light [#0068c8](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    tile_quick_action_on_off_press_in_glyph:
      'var(--theme-device-tile-quick-action-on-off-press-in-glyph)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-speaker-fill)](./css/vars/theme-device.css)
     * @css-source-light [rgba(117, 0, 251, 0.1)](./css/vars/theme-device.css)
     * @css-source-dark [rgba(144, 51, 252, 0.2)](./css/vars/theme-device.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     */
    tile_quick_action_speaker_fill: 'var(--theme-device-tile-quick-action-speaker-fill)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-speaker-glyph)](./css/vars/theme-device.css)
     * @css-source-light [#7500fb](./css/vars/theme-device.css)
     * @css-source-dark [#ac66fd](./css/vars/theme-device.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     */
    tile_quick_action_speaker_glyph: 'var(--theme-device-tile-quick-action-speaker-glyph)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-speaker-press-in-fill)](./css/vars/theme-device.css)
     * @css-source-light [rgba(117, 0, 251, 0.2)](./css/vars/theme-device.css)
     * @css-source-dark [rgba(144, 51, 252, 0.4)](./css/vars/theme-device.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     */
    tile_quick_action_speaker_press_in_fill:
      'var(--theme-device-tile-quick-action-speaker-press-in-fill)',
    /**
     * @css-value [var(--theme-device-tile-quick-action-speaker-press-in-glyph)](./css/vars/theme-device.css)
     * @css-source-light [#4a00a1](./css/vars/theme-device.css)
     * @css-source-dark [#ac66fd](./css/vars/theme-device.css)
     * @see [./css/vars/theme-device.css](./css/vars/theme-device.css)
     */
    tile_quick_action_speaker_press_in_glyph:
      'var(--theme-device-tile-quick-action-speaker-press-in-glyph)',
  },
  filter: {
    /**
     * @css-value [var(--theme-filter-dark-mode)](./css/vars/theme-filter.css)
     * @css-source-light [none](./css/vars/theme-filter.css)
     * @css-source-dark [invert(1) hue-rotate(180deg)](./css/vars/theme-filter.css)
     * @see [./css/vars/theme-filter.css](./css/vars/theme-filter.css)
     */
    dark_mode: 'var(--theme-filter-dark-mode)',
  },
  flowcard: {
    /**
     * @css-value [var(--theme-flowcard-background)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-component)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-000)](./css/vars/theme-color.css)
     * @css-source-light [#ffffff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-dark [#292a2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    background: 'var(--theme-flowcard-background)',
    /**
     * @css-value [var(--theme-flowcard-connector-out)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_out: 'var(--theme-flowcard-connector-out)',
    /**
     * @css-value [var(--theme-flowcard-connector-out-hover)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-blue-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-light [#339bfb](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-hover)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-300)](./css/vars/theme-color.css)
     * @css-source-dark [#66b4fc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_out_hover: 'var(--theme-flowcard-connector-out-hover)',
    /**
     * @css-value [var(--theme-flowcard-connector-out-active)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-blue-active)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-600)](./css/vars/theme-color.css)
     * @css-source-light [#0068c8](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-active)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-dark [#0082fa](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_out_active: 'var(--theme-flowcard-connector-out-active)',
    /**
     * @css-value [var(--theme-flowcard-connector-true)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_true: 'var(--theme-flowcard-connector-true)',
    /**
     * @css-value [var(--theme-flowcard-connector-true-hover)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-blue-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-light [#339bfb](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-hover)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-300)](./css/vars/theme-color.css)
     * @css-source-dark [#66b4fc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_true_hover: 'var(--theme-flowcard-connector-true-hover)',
    /**
     * @css-value [var(--theme-flowcard-connector-true-active)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_true_active: 'var(--theme-flowcard-connector-true-active)',
    /**
     * @css-value [var(--theme-flowcard-connector-false)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-color-yellow)](./css/vars/theme-color.css)
     * @css-source [#f5b207](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_false: 'var(--theme-flowcard-connector-false)',
    /**
     * @css-value [var(--theme-flowcard-connector-false-hover)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-color-yellow-hover)](./css/vars/theme-color.css)
     * @css-source [#f9c43e](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_false_hover: 'var(--theme-flowcard-connector-false-hover)',
    /**
     * @css-value [var(--theme-flowcard-connector-false-active)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-color-yellow-active)](./css/vars/theme-color.css)
     * @css-source [#e9a907](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_false_active: 'var(--theme-flowcard-connector-false-active)',
    /**
     * @css-value [var(--theme-flowcard-connector-error)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-color-red)](./css/vars/theme-color.css)
     * @css-source [#d81c1d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_error: 'var(--theme-flowcard-connector-error)',
    /**
     * @css-value [var(--theme-flowcard-connector-error-hover)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-color-red-hover)](./css/vars/theme-color.css)
     * @css-source [#e0494a](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_error_hover: 'var(--theme-flowcard-connector-error-hover)',
    /**
     * @css-value [var(--theme-flowcard-connector-error-active)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-color-red-active)](./css/vars/theme-color.css)
     * @css-source [#ad1617](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    connector_error_active: 'var(--theme-flowcard-connector-error-active)',
    /**
     * @css-value [var(--theme-flowcard-dropzone-target-background)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    dropzone_target_background: 'var(--theme-flowcard-dropzone-target-background)',
    /**
     * @css-value [var(--theme-flowcard-dropzone-target-outline)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-blue-o-20)](./css/vars/theme-color.css)
     * @css-source-light [rgba(0, 130, 250, 0.2)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-o-30)](./css/vars/theme-color.css)
     * @css-source-dark [rgba(0, 130, 250, 0.3)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    dropzone_target_outline: 'var(--theme-flowcard-dropzone-target-outline)',
    /**
     * @css-value [var(--theme-flowcard-dragover-border)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    dragover_border: 'var(--theme-flowcard-dragover-border)',
    /**
     * @css-value [var(--theme-flowcard-dragover-background)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-color-blue-050)](./css/vars/theme-color.css)
     * @css-source-light [#e6f3ff](./css/vars/theme-color.css)
     * @css-source-dark [#1e2c3d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    dragover_background: 'var(--theme-flowcard-dragover-background)',
    /**
     * @css-value [var(--theme-flowcard-dragging-and-can-connect-shadow)](./css/vars/theme-flowcard.css)
     * @css-source [0 10px 44px 0 rgba(0, 130, 250, 0.14), 0 2px 12px 0 rgba(0, 130, 250, 0.2), 0 2px 4px 0 rgba(0, 130, 250, 0.2)](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    dragging_and_can_connect_shadow: 'var(--theme-flowcard-dragging-and-can-connect-shadow)',
    /**
     * @css-value [var(--theme-flowcard-invalid-shadow)](./css/vars/theme-flowcard.css)
     * @css-source [0 10px 44px 0 rgba(216, 28, 29, 0.14), 0 2px 12px 0 rgba(216, 28, 29, 0.2), 0 2px 4px 0 rgba(216, 28, 29, 0.2)](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    invalid_shadow: 'var(--theme-flowcard-invalid-shadow)',
    /**
     * @css-value [var(--theme-flowcard-disabled-color-text)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-light [#c8c8d0](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    disabled_color_text: 'var(--theme-flowcard-disabled-color-text)',
    /**
     * @css-value [var(--theme-flowcard-disabled-background-color)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-light [#dadae2](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    disabled_background_color: 'var(--theme-flowcard-disabled-background-color)',
    /**
     * @css-value [var(--theme-flowcard-disabled-icon-color)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-white)](./css/vars/theme-color.css)
     * @css-source-light [#ffffff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-300)](./css/vars/theme-color.css)
     * @css-source-dark [#58595d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    disabled_icon_color: 'var(--theme-flowcard-disabled-icon-color)',
    /**
     * @css-value [var(--theme-flowcard-name-color)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-text-light)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-400)](./css/vars/theme-color.css)
     * @css-source-light [#93939a](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-text-light)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-600)](./css/vars/theme-color.css)
     * @css-source-dark [#a0a0a3](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    name_color: 'var(--theme-flowcard-name-color)',
    /**
     * @css-value [var(--theme-flowcard-name-font-size)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-font-size-tiny)](./css/vars/theme-font-size.css)
     * @css-source [12px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    name_font_size: 'var(--theme-flowcard-name-font-size)',
    /**
     * @css-value [var(--theme-flowcard-name-line-height)](./css/vars/theme-flowcard.css)
     * @css-source [1.667](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     */
    name_line_height: 'var(--theme-flowcard-name-line-height)',
    /**
     * @css-value [var(--theme-flowcard-content-font-size)](./css/vars/theme-flowcard.css)
     * @css-value-path [var(--theme-font-size-regular)](./css/vars/theme-font-size.css)
     * @css-source [16px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    content_font_size: 'var(--theme-flowcard-content-font-size)',
    /**
     * @css-value [var(--theme-flowcard-content-line-height)](./css/vars/theme-flowcard.css)
     * @css-source [1.3125](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     */
    content_line_height: 'var(--theme-flowcard-content-line-height)',
    /**
     * @css-value [var(--theme-flowcard-title-color)](./css/vars/theme-flowcard.css)
     * @css-value-path-light [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-light [#c8c8d0](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-400)](./css/vars/theme-color.css)
     * @css-source-dark [#707175](./css/vars/theme-color.css)
     * @see [./css/vars/theme-flowcard.css](./css/vars/theme-flowcard.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    title_color: 'var(--theme-flowcard-title-color)',
  },
  fontSize: {
    /**
     * @css-value [var(--theme-font-size-xtiny)](./css/vars/theme-font-size.css)
     * @css-source [10px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    xtiny: 'var(--theme-font-size-xtiny)',
    /**
     * @css-value [var(--theme-font-size-tiny)](./css/vars/theme-font-size.css)
     * @css-source [12px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    tiny: 'var(--theme-font-size-tiny)',
    /**
     * @css-value [var(--theme-font-size-small)](./css/vars/theme-font-size.css)
     * @css-source [14px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    small: 'var(--theme-font-size-small)',
    /**
     * @css-value [var(--theme-font-size-regular)](./css/vars/theme-font-size.css)
     * @css-source [16px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    regular: 'var(--theme-font-size-regular)',
    /**
     * @css-value [var(--theme-font-size-heading4)](./css/vars/theme-font-size.css)
     * @css-source [18px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    heading4: 'var(--theme-font-size-heading4)',
    /**
     * @css-value [var(--theme-font-size-heading3)](./css/vars/theme-font-size.css)
     * @css-source [20px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    heading3: 'var(--theme-font-size-heading3)',
    /**
     * @css-value [var(--theme-font-size-heading2)](./css/vars/theme-font-size.css)
     * @css-source [24px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    heading2: 'var(--theme-font-size-heading2)',
    /**
     * @css-value [var(--theme-font-size-heading1)](./css/vars/theme-font-size.css)
     * @css-source [36px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    heading1: 'var(--theme-font-size-heading1)',
    /**
     * @css-value [var(--theme-font-size-hero1)](./css/vars/theme-font-size.css)
     * @css-source [48px](./css/vars/theme-font-size.css)
     * @see [./css/vars/theme-font-size.css](./css/vars/theme-font-size.css)
     */
    hero1: 'var(--theme-font-size-hero1)',
  },
  fontWeight: {
    /**
     * @css-value [var(--theme-font-weight-regular)](./css/vars/theme-font-weight.css)
     * @css-source [400](./css/vars/theme-font-weight.css)
     * @see [./css/vars/theme-font-weight.css](./css/vars/theme-font-weight.css)
     */
    regular: 'var(--theme-font-weight-regular)',
    /**
     * @css-value [var(--theme-font-weight-medium)](./css/vars/theme-font-weight.css)
     * @css-source [500](./css/vars/theme-font-weight.css)
     * @see [./css/vars/theme-font-weight.css](./css/vars/theme-font-weight.css)
     */
    medium: 'var(--theme-font-weight-medium)',
    /**
     * @css-value [var(--theme-font-weight-bold)](./css/vars/theme-font-weight.css)
     * @css-source [700](./css/vars/theme-font-weight.css)
     * @see [./css/vars/theme-font-weight.css](./css/vars/theme-font-weight.css)
     */
    bold: 'var(--theme-font-weight-bold)',
    /**
     * @css-value [var(--theme-font-weight-black)](./css/vars/theme-font-weight.css)
     * @css-source [900](./css/vars/theme-font-weight.css)
     * @see [./css/vars/theme-font-weight.css](./css/vars/theme-font-weight.css)
     */
    black: 'var(--theme-font-weight-black)',
  },
  gradientButton: {
    /**
     * @css-value [var(--theme-gradient-button-background-position-default)](./css/vars/theme-gradient-button.css)
     * @css-source [33% top](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-gradient-button.css](./css/vars/theme-gradient-button.css)
     */
    background_position_default: 'var(--theme-gradient-button-background-position-default)',
    /**
     * @css-value [var(--theme-gradient-button-background-position-hover)](./css/vars/theme-gradient-button.css)
     * @css-source [66% top](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-gradient-button.css](./css/vars/theme-gradient-button.css)
     */
    background_position_hover: 'var(--theme-gradient-button-background-position-hover)',
    /**
     * @css-value [var(--theme-gradient-button-background-position-active)](./css/vars/theme-gradient-button.css)
     * @css-source [15% top](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-gradient-button.css](./css/vars/theme-gradient-button.css)
     */
    background_position_active: 'var(--theme-gradient-button-background-position-active)',
    /**
     * @css-value [var(--theme-gradient-button-background-size)](./css/vars/theme-gradient-button.css)
     * @css-source [200% 100%](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-gradient-button.css](./css/vars/theme-gradient-button.css)
     */
    background_size: 'var(--theme-gradient-button-background-size)',
    /**
     * @css-value [var(--theme-gradient-button-background-color-blue)](./css/vars/theme-gradient-button.css)
     * @css-source [linear-gradient( 30deg, #005cd5, #367cff 33%, #52baff 66%, #52deff )](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-gradient-button.css](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    background_color_blue: 'var(--theme-gradient-button-background-color-blue)',
    /**
     * @css-value [var(--theme-gradient-button-background-color-pink)](./css/vars/theme-gradient-button.css)
     * @css-source [linear-gradient( 30deg, #c70076, #e90090 33%, #fc6767 66%, #fc6767 )](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-gradient-button.css](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    background_color_pink: 'var(--theme-gradient-button-background-color-pink)',
    /**
     * @css-value [var(--theme-gradient-button-background-color-purple)](./css/vars/theme-gradient-button.css)
     * @css-source [linear-gradient( 30deg, #751fff, #881fff 33%, #d41dff 66%, #e81dff )](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-gradient-button.css](./css/vars/theme-gradient-button.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    background_color_purple: 'var(--theme-gradient-button-background-color-purple)',
  },
  icon: {
    /**
     * @css-value [var(--theme-icon-size-xxlarge)](./css/vars/theme-icon.css)
     * @css-source [36px](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    size_xxlarge: 'var(--theme-icon-size-xxlarge)',
    /**
     * @css-value [var(--theme-icon-size-xlarge)](./css/vars/theme-icon.css)
     * @css-source [32px](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    size_xlarge: 'var(--theme-icon-size-xlarge)',
    /**
     * @css-value [var(--theme-icon-size-large)](./css/vars/theme-icon.css)
     * @css-source [28px](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    size_large: 'var(--theme-icon-size-large)',
    /**
     * @css-value [var(--theme-icon-size-medium)](./css/vars/theme-icon.css)
     * @css-source [24px](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    size_medium: 'var(--theme-icon-size-medium)',
    /**
     * @css-value [var(--theme-icon-size-default)](./css/vars/theme-icon.css)
     * @css-source [20px](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    size_default: 'var(--theme-icon-size-default)',
    /**
     * @css-value [var(--theme-icon-size-18)](./css/vars/theme-icon.css)
     * @css-source [18px](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    size_18: 'var(--theme-icon-size-18)',
    /**
     * @css-value [var(--theme-icon-size-small)](./css/vars/theme-icon.css)
     * @css-source [16px](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    size_small: 'var(--theme-icon-size-small)',
    /**
     * @css-value [var(--theme-icon-size-tiny)](./css/vars/theme-icon.css)
     * @css-source [12px](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    size_tiny: 'var(--theme-icon-size-tiny)',
    /**
     * @css-value [var(--theme-icon-scale-large)](./css/vars/theme-icon.css)
     * @css-source [1.0714285714](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_large: 'var(--theme-icon-scale-large)',
    /**
     * @css-value [var(--theme-icon-scale-default)](./css/vars/theme-icon.css)
     * @css-source [1.1](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_default: 'var(--theme-icon-scale-default)',
    /**
     * @css-value [var(--theme-icon-scale-small)](./css/vars/theme-icon.css)
     * @css-source [1.125](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_small: 'var(--theme-icon-scale-small)',
    /**
     * @css-value [var(--theme-icon-scale-tiny)](./css/vars/theme-icon.css)
     * @css-source [1.1666666667](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_tiny: 'var(--theme-icon-scale-tiny)',
    /**
     * @css-value [var(--theme-icon-scale-hover-large)](./css/vars/theme-icon.css)
     * @css-source [1.0714285714](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_hover_large: 'var(--theme-icon-scale-hover-large)',
    /**
     * @css-value [var(--theme-icon-scale-hover-default)](./css/vars/theme-icon.css)
     * @css-source [1.1](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_hover_default: 'var(--theme-icon-scale-hover-default)',
    /**
     * @css-value [var(--theme-icon-scale-hover-small)](./css/vars/theme-icon.css)
     * @css-source [1.125](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_hover_small: 'var(--theme-icon-scale-hover-small)',
    /**
     * @css-value [var(--theme-icon-scale-hover-tiny)](./css/vars/theme-icon.css)
     * @css-source [1.1666666667](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_hover_tiny: 'var(--theme-icon-scale-hover-tiny)',
    /**
     * @css-value [var(--theme-icon-scale-press-large)](./css/vars/theme-icon.css)
     * @css-source [0.9285](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_press_large: 'var(--theme-icon-scale-press-large)',
    /**
     * @css-value [var(--theme-icon-scale-press-default)](./css/vars/theme-icon.css)
     * @css-source [0.9](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_press_default: 'var(--theme-icon-scale-press-default)',
    /**
     * @css-value [var(--theme-icon-scale-press-small)](./css/vars/theme-icon.css)
     * @css-source [0.875](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_press_small: 'var(--theme-icon-scale-press-small)',
    /**
     * @css-value [var(--theme-icon-scale-press-tiny)](./css/vars/theme-icon.css)
     * @css-source [0.8333](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     */
    scale_press_tiny: 'var(--theme-icon-scale-press-tiny)',
    /**
     * @css-value [var(--theme-icon-color-light)](./css/vars/theme-icon.css)
     * @css-value-path-light [var(--theme-color-icon-light)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-300)](./css/vars/theme-color.css)
     * @css-source-light [#b1b1b9](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-icon-light)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-600)](./css/vars/theme-color.css)
     * @css-source-dark [#a0a0a3](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_light: 'var(--theme-icon-color-light)',
    /**
     * @css-value [var(--theme-icon-color-light-hover)](./css/vars/theme-icon.css)
     * @css-value-path-light [var(--theme-color-icon-light-hover)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-400)](./css/vars/theme-color.css)
     * @css-source-light [#93939a](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-icon-light-hover)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-700)](./css/vars/theme-color.css)
     * @css-source-dark [#b8b8ba](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_light_hover: 'var(--theme-icon-color-light-hover)',
    /**
     * @css-value [var(--theme-icon-color-light-inactive)](./css/vars/theme-icon.css)
     * @css-value-path-light [var(--theme-color-icon-light-inactive)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-050)](./css/vars/theme-color.css)
     * @css-source-light [#eaeaf1](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-icon-light-inactive)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_light_inactive: 'var(--theme-icon-color-light-inactive)',
    /**
     * @css-value [var(--theme-icon-color-body-light)](./css/vars/theme-icon.css)
     * @css-value-path [var(--theme-color-icon-body-light)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-400)](./css/vars/theme-color.css)
     * @css-source-light [#93939a](./css/vars/theme-color.css)
     * @css-source-dark [#707175](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_body_light: 'var(--theme-icon-color-body-light)',
    /**
     * @css-value [var(--theme-icon-color-body-light-hover)](./css/vars/theme-icon.css)
     * @css-value-path [var(--theme-color-icon-body-light-hover)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-500)](./css/vars/theme-color.css)
     * @css-source-light [#7a7a7f](./css/vars/theme-color.css)
     * @css-source-dark [#88898c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_body_light_hover: 'var(--theme-icon-color-body-light-hover)',
    /**
     * @css-value [var(--theme-icon-color-medium)](./css/vars/theme-icon.css)
     * @css-value-path [var(--theme-color-mono-500)](./css/vars/theme-color.css)
     * @css-source-light [#7a7a7f](./css/vars/theme-color.css)
     * @css-source-dark [#88898c](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_medium: 'var(--theme-icon-color-medium)',
    /**
     * @css-value [var(--theme-icon-color-medium-hover)](./css/vars/theme-icon.css)
     * @css-value-path [var(--theme-color-mono-600)](./css/vars/theme-color.css)
     * @css-source-light [#626265](./css/vars/theme-color.css)
     * @css-source-dark [#a0a0a3](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_medium_hover: 'var(--theme-icon-color-medium-hover)',
    /**
     * @css-value [var(--theme-icon-color-dark)](./css/vars/theme-icon.css)
     * @css-value-path [var(--theme-color-icon-dark)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-mono-800)](./css/vars/theme-color.css)
     * @css-source-light [#303031](./css/vars/theme-color.css)
     * @css-source-dark [#cfcfd1](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_dark: 'var(--theme-icon-color-dark)',
    /**
     * @css-value [var(--theme-icon-color-blue)](./css/vars/theme-icon.css)
     * @css-value-path-light [var(--theme-color-icon-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-icon-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_blue: 'var(--theme-icon-color-blue)',
    /**
     * @css-value [var(--theme-icon-color-blue-hover)](./css/vars/theme-icon.css)
     * @css-value-path-light [var(--theme-color-blue-600)](./css/vars/theme-color.css)
     * @css-source-light [#0068c8](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-300)](./css/vars/theme-color.css)
     * @css-source-dark [#66b4fc](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_blue_hover: 'var(--theme-icon-color-blue-hover)',
    /**
     * @css-value [var(--theme-icon-color-white)](./css/vars/theme-icon.css)
     * @css-value-path [var(--theme-color-icon-white)](./css/vars/theme-color.css)
     * @css-value-path [var(--theme-color-white)](./css/vars/theme-color.css)
     * @css-source [#ffffff](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_white: 'var(--theme-icon-color-white)',
    /**
     * @css-value [var(--theme-icon-color-disabled)](./css/vars/theme-icon.css)
     * @css-value-path-light [var(--theme-color-icon-disabled)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-light [#dadae2](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-icon-disabled)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-icon.css](./css/vars/theme-icon.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    color_disabled: 'var(--theme-icon-color-disabled)',
  },
  input: {
    /**
     * @css-value [var(--theme-input-height-default)](./css/vars/theme-input.css)
     * @css-source [30px](./css/vars/theme-input.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     */
    height_default: 'var(--theme-input-height-default)',
    /**
     * @css-value [var(--theme-input-height-medium)](./css/vars/theme-input.css)
     * @css-source [40px](./css/vars/theme-input.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     */
    height_medium: 'var(--theme-input-height-medium)',
    /**
     * @css-value [var(--theme-input-height-large)](./css/vars/theme-input.css)
     * @css-source [50px](./css/vars/theme-input.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     */
    height_large: 'var(--theme-input-height-large)',
    /**
     * @css-value [var(--theme-input-border)](./css/vars/theme-input.css)
     * @css-value-path-light [var(--theme-color-line)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-light [#dadae2](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-line)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-200)](./css/vars/theme-color.css)
     * @css-source-dark [#414247](./css/vars/theme-color.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    border: 'var(--theme-input-border)',
    /**
     * @css-value [var(--theme-input-border-hover)](./css/vars/theme-input.css)
     * @css-value-path [var(--theme-color-mono-150)](./css/vars/theme-color.css)
     * @css-source-light [#d1d2d5](./css/vars/theme-color.css)
     * @css-source-dark [#35363b](./css/vars/theme-color.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    border_hover: 'var(--theme-input-border-hover)',
    /**
     * @css-value [var(--theme-input-border-selected)](./css/vars/theme-input.css)
     * @css-value-path-light [var(--theme-color-highlight)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-highlight)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    border_selected: 'var(--theme-input-border-selected)',
    /**
     * @css-value [var(--theme-input-border-focus)](./css/vars/theme-input.css)
     * @css-value-path [var(--theme-color-blue-o-50)](./css/vars/theme-color.css)
     * @css-source [rgba(0, 130, 250, 0.5)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    border_focus: 'var(--theme-input-border-focus)',
    /**
     * @css-value [var(--theme-input-border-error)](./css/vars/theme-input.css)
     * @css-value-path [var(--theme-color-red-o-50)](./css/vars/theme-color.css)
     * @css-source [rgba(216, 28, 29, 0.5)](./css/vars/theme-color.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    border_error: 'var(--theme-input-border-error)',
    /**
     * @css-value [var(--theme-input-border-disabled)](./css/vars/theme-input.css)
     * @css-value-path [var(--theme-color-mono-300)](./css/vars/theme-color.css)
     * @css-source-light [#b1b1b9](./css/vars/theme-color.css)
     * @css-source-dark [#58595d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    border_disabled: 'var(--theme-input-border-disabled)',
    /**
     * @css-value [var(--theme-input-background)](./css/vars/theme-input.css)
     * @css-value-path-light [var(--theme-color-component)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-000)](./css/vars/theme-color.css)
     * @css-source-light [#ffffff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-component)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-050)](./css/vars/theme-color.css)
     * @css-source-dark [#1e1f24](./css/vars/theme-color.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    background: 'var(--theme-input-background)',
    /**
     * @css-value [var(--theme-input-background-selected)](./css/vars/theme-input.css)
     * @css-value-path-light [var(--theme-color-highlight)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-blue-500)](./css/vars/theme-color.css)
     * @css-source-light [#0082fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-highlight)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-blue-400)](./css/vars/theme-color.css)
     * @css-source-dark [#339bfb](./css/vars/theme-color.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    background_selected: 'var(--theme-input-background-selected)',
    /**
     * @css-value [var(--theme-input-box-shadow-hover)](./css/vars/theme-input.css)
     * @css-source [0 0 3px 0px rgba(0, 0, 0, 0.1)](./css/vars/theme-input.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     */
    box_shadow_hover: 'var(--theme-input-box-shadow-hover)',
    /**
     * @css-value [var(--theme-input-box-shadow-focus)](./css/vars/theme-input.css)
     * @css-source [0 0 3px 0px rgba(0, 130, 250, 0.5)](./css/vars/theme-input.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     */
    box_shadow_focus: 'var(--theme-input-box-shadow-focus)',
    /**
     * @css-value [var(--theme-input-box-shadow-error)](./css/vars/theme-input.css)
     * @css-source [0 0 3px 0px rgba(216, 28, 29, 0.5)](./css/vars/theme-input.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     */
    box_shadow_error: 'var(--theme-input-box-shadow-error)',
    /**
     * @css-value [var(--theme-input-border-radius)](./css/vars/theme-input.css)
     * @css-value-path [var(--theme-border-radius-small)](./css/vars/theme-border-radius.css)
     * @css-source [5px](./css/vars/theme-border-radius.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-border-radius.css](./css/vars/theme-border-radius.css)
     */
    border_radius: 'var(--theme-input-border-radius)',
    /**
     * @css-value [var(--theme-input-search-border)](./css/vars/theme-input.css)
     * @css-source [transparent](./css/vars/theme-input.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     */
    search_border: 'var(--theme-input-search-border)',
    /**
     * @css-value [var(--theme-input-search-background)](./css/vars/theme-input.css)
     * @css-value-path-light [var(--theme-color-body)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-025)](./css/vars/theme-color.css)
     * @css-source-light [#f4f4fa](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-020)](./css/vars/theme-color.css)
     * @css-source-dark [#16171d](./css/vars/theme-color.css)
     * @see [./css/vars/theme-input.css](./css/vars/theme-input.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    search_background: 'var(--theme-input-search-background)',
  },
  monoButton: {
    /**
     * @css-value [var(--theme-mono-button-background)](./css/vars/theme-mono-button.css)
     * @css-value-path-light [var(--theme-color-component)](./css/vars/theme-color.css)
     * @css-value-path-light [var(--theme-color-mono-000)](./css/vars/theme-color.css)
     * @css-source-light [#ffffff](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-component)](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-050)](./css/vars/theme-color.css)
     * @css-source-dark [#1e1f24](./css/vars/theme-color.css)
     * @see [./css/vars/theme-mono-button.css](./css/vars/theme-mono-button.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    background: 'var(--theme-mono-button-background)',
    /**
     * @css-value [var(--theme-mono-button-background-hover)](./css/vars/theme-mono-button.css)
     * @css-value-path-light [var(--theme-color-mono-010)](./css/vars/theme-color.css)
     * @css-source-light [#fbfbfd](./css/vars/theme-color.css)
     * @css-value-path-dark [var(--theme-color-mono-100)](./css/vars/theme-color.css)
     * @css-source-dark [#292a2f](./css/vars/theme-color.css)
     * @see [./css/vars/theme-mono-button.css](./css/vars/theme-mono-button.css)
     * @see [./css/vars/theme-color.css](./css/vars/theme-color.css)
     */
    background_hover: 'var(--theme-mono-button-background-hover)',
  },
  zIndex: {
    /**
     * @css-value [var(--theme-z-index-content)](./css/vars/theme-z-index.css)
     * @css-source [100](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    content: 'var(--theme-z-index-content)',
    /**
     * @css-value [var(--theme-z-index-nav)](./css/vars/theme-z-index.css)
     * @css-source [200](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    nav: 'var(--theme-z-index-nav)',
    /**
     * @css-value [var(--theme-z-index-advanced-flow-view)](./css/vars/theme-z-index.css)
     * @css-source [300](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    advanced_flow_view: 'var(--theme-z-index-advanced-flow-view)',
    /**
     * @css-value [var(--theme-z-index-header)](./css/vars/theme-z-index.css)
     * @css-source [400](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    header: 'var(--theme-z-index-header)',
    /**
     * @css-value [var(--theme-z-index-beta)](./css/vars/theme-z-index.css)
     * @css-source [500](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    beta: 'var(--theme-z-index-beta)',
    /**
     * @css-value [var(--theme-z-index-overlay)](./css/vars/theme-z-index.css)
     * @css-source [600](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    overlay: 'var(--theme-z-index-overlay)',
    /**
     * @css-value [var(--theme-z-index-drag-layer)](./css/vars/theme-z-index.css)
     * @css-source [700](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    drag_layer: 'var(--theme-z-index-drag-layer)',
    /**
     * @css-value [var(--theme-z-index-dialog)](./css/vars/theme-z-index.css)
     * @css-source [800](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    dialog: 'var(--theme-z-index-dialog)',
    /**
     * @css-value [var(--theme-z-index-toasts)](./css/vars/theme-z-index.css)
     * @css-source [1000](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    toasts: 'var(--theme-z-index-toasts)',
    /**
     * @css-value [var(--theme-z-index-tooltip)](./css/vars/theme-z-index.css)
     * @css-source [1100](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    tooltip: 'var(--theme-z-index-tooltip)',
    /**
     * @css-value [var(--theme-z-index-disabled-layer)](./css/vars/theme-z-index.css)
     * @css-source [10000](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    disabled_layer: 'var(--theme-z-index-disabled-layer)',
    /**
     * @css-value [var(--theme-z-index-cursor)](./css/vars/theme-z-index.css)
     * @css-source [20000](./css/vars/theme-z-index.css)
     * @see [./css/vars/theme-z-index.css](./css/vars/theme-z-index.css)
     */
    cursor: 'var(--theme-z-index-cursor)',
  },
} as const;

export type Theme = typeof theme;
